import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shield, Server } from 'lucide-react';

export default function Login() {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-xl shadow-lg border border-slate-200 dark:border-slate-800 p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-sky-600 rounded-lg text-white">
            <Server size={24} />
          </div>
          <div>
            <h1 className="text-2xl font-bold">vStore</h1>
            <p className="text-sm text-slate-500">Storage Management Platform</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 rounded-md bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 focus:border-sky-500 focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded-md bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 focus:border-sky-500 focus:outline-none"
              required
            />
          </div>
          {error && <div className="text-sm text-rose-500">{error}</div>}
          <button
            type="submit"
            className="w-full py-2 bg-sky-600 hover:bg-sky-700 text-white font-medium rounded-md transition-colors"
          >
            Sign in
          </button>
        </form>
        <div className="mt-6 flex items-start gap-2 text-xs text-slate-500 bg-slate-100 dark:bg-slate-800 p-3 rounded-md">
          <Shield size={14} className="mt-0.5" />
          <span>Demo credentials: admin / admin</span>
        </div>
      </div>
    </div>
  );
}
